// Data sevice
import axios from 'axios'
import authHeader from './auth-header'
axios.defaults.headers.common['Access-Control-Allow-Origin'] = '*';
const API_URL = process.env.VUE_APP_API_URL;

class CompanySizeService {

    index() {
        return axios.get(API_URL + 'company-sizes', { headers: authHeader() })
    }
    show(id) {
        return axios.get(API_URL + 'company-sizes/' + id, { headers: authHeader() })
    }
    store(resource) {
        return axios.post(API_URL + 'company-sizes', resource, { headers: authHeader() })
    }
    update(resource) {
        return axios.put(API_URL + 'company-sizes/' + resource.id, resource, { headers: authHeader() })
    }
    delete(resource) {
        return axios.delete(API_URL + 'company-sizes/' + resource.id, { headers: authHeader() })
    }

}

export default new CompanySizeService()